import * as React from "react";
import PropTypes from "prop-types";
import Drawer from "@material-ui/core/Drawer";

import BackButtonResponder from "./BackButtonResponder";
import Theme from "./Theme";
import ColorsProvider from "./ColorsProvider";

function getWidth() {
  // Hack to get a safe width for iPhones with a notch when in landscape.
  const span = document.createElement("span");
  Object.assign(span.style, {
    position: "absolute",
    pointerEvents: "none",
    paddingTop: Theme.Padding.SAFE_AREA_TOP,
    paddingRight: Theme.Padding.SAFE_AREA_RIGHT,
    paddingBottom: Theme.Padding.SAFE_AREA_BOTTOM,
    paddingLeft: Theme.Padding.SAFE_AREA_LEFT,
  });
  document.body.appendChild(span);
  const styles = window.getComputedStyle(span);
  const hasSafeArea = styles.padding !== "0px";
  document.body.removeChild(span);
  return 275 + (hasSafeArea ? 22 : 0);
}

export default class AppDrawer extends React.Component {
  static WIDTH = getWidth();

  static propTypes = {
    children: PropTypes.node,
    open: PropTypes.bool,
    docked: PropTypes.bool,
    onRequestChange: PropTypes.func,
  };

  static defaultProps = {
    docked: false,
  };

  componentDidMount() {
    AppDrawer.WIDTH = getWidth(); // This doesn't seem to be correct during the
  }

  render() {
    const { children, open, docked, onRequestChange } = this.props;

    return (
      <React.Fragment>
        {open && (
          <BackButtonResponder
            onPressed={() => {
              onRequestChange(false);
              return { handled: true };
            }}
          />
        )}
        <ColorsProvider>
          {() => (
            // we don't use colors directly, but ColorsProvider also wraps its
            // children in a MuiThemeProvider whose MUI theme is based on the
            // current colorSet, so we are relying on that.
            <div aria-hidden={!open}>
              <Drawer
                open={open}
                variant={docked ? "permanent" : "temporary"}
                onClose={onRequestChange}
                ref={(drawer) => (this._muiDrawer = drawer)}
                PaperProps={{
                  // The more appropriate way for styling the Paper sub-component is using MUI's withStyles
                  // but that breaks Drawer's animations. For now pass styling directly to Paper
                  // so as long as we have that prop to do so.
                  style: {
                    width: AppDrawer.WIDTH,
                    border: "none",
                    boxShadow:
                      "rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px", // Note: was not originally added by Nexia or Pivot, was it from mui 0.15.0?
                  },
                }}
              >
                {children}
              </Drawer>
            </div>
          )}
        </ColorsProvider>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/AppDrawer.jsx